export const formatDate = (val: string) => {
  const date = new Date(val)
  const month = date.getMonth() + 1
  const formattedDate = `${date.getDate()}/${month}/${date.getFullYear()}`

  return formattedDate
}
